import Redux from "@hlibs/react/redux";
import Account from "./account";
import Advertiser from "./advertiser";
import Socket from "./socket";
import Config from "./config";
import Advertisement from "./advertisement";
import Files from "./files";

// 커스텀 혹은 외부 reducer 가 있으면 여기에 추가
const reducers = {};

// 커스텀 혹은 외부 saga 가 있으면 여기에 추가
const sagas = {};

// hlibs/redux 의 모듈들 혹은 스타일에 맞게 만든 redux / redux-saga 모듈(대표적으로 redux/account)의 경우 여기에 추가.
const reduxModules = {
  Account,
  Advertisement,
  Advertiser,
  Files,
  //    Socket,
  Config,
};

export const createStore = () => {
  return Redux.createStore(reduxModules, reducers, sagas);
};

export default reduxModules;
